import DocumentTypeKey from '../../../../../../enums/DocumentTypeKey';

const legalBackgroundItems = [
  {
    label: 'Copia escritura pública de constitución de sociedad.',
    key: DocumentTypeKey.SOCIETY_CONSTITUTION_COPY,
  },
  {
    label: 'Copia extracto y publicación en el Diario Oficial.',
    key: DocumentTypeKey.OFICIAL_JOURNAL_EXTRACT,
  },
  {
    label:
      'Inscripción social con notas marginales y certificado de vigencia no superior a 60 días.',
    key: DocumentTypeKey.SOCIAL_INSCRIPTION,
  },
  {
    label: 'Copia de modificaciones posteriores con sus respectivas inscripciones.',
    key: DocumentTypeKey.SUBSEQUENT_CONSTITUTION_MODIFICATIONS,
  },
  {
    label: 'Poderes:',
    asideLabel:
      'Si no están anotados al margen de la inscripción social y fueron otorgados hace más de 1 año, se debe acompañar una copia del poder con timbre del archivero judicial, con fecha no superior a 60 días, acreditando que no existe constancia al margen de que el poder haya sido revocado.',
    key: DocumentTypeKey.POWER,
  },
  {
    label: 'Fotocopia de RUT de la sociedad',
    key: DocumentTypeKey.SOCIETY_RUT,
  },
  {
    label: 'Otros documentos.',
    key: DocumentTypeKey.OTHER_DOCUMENTS,
  },
];

export default legalBackgroundItems;
